export default {
    // index.vue
    welcome_login: 'Welcome to log in',
    meeting_backend: 'Meeting backend management',

    // forum-config/info.vue
    forum_config: {
        enter_forum_id: 'Please enter the forum ID',
        forum_name: 'Forum name',
        enter_forum_name: 'Please enter the forum name',
        forum_name_en: 'Forum English name',
        enter_forum_name_en: 'Please enter the forum English name',
        start_time: 'Start time',
        select_start_time: 'Please select the start time',
        region: 'Region',
        address: 'Detailed address',
        enter_address: 'Please enter the detailed address',
        cover_image: 'Cover image',
        upload_cover: 'Please upload the cover image',
        upload_image: 'Upload image',
        intro: 'Introduction',
        enter_intro: 'Please enter the introduction',
        submit: 'Submit now',
        operation_success: 'Operation successful',
        only_image: 'You can only upload image files'
    },

    // goods-module/goods.vue
    goods: {
        enter_ticket_name: 'Please enter the ticket name',
        select_ticket_status: 'Please select the ticket status',
        select_ticket_type: 'Please select the ticket type',
        search: 'Search',
        reset: 'Reset',
        unlimited: 'Unlimited',
        put_on: 'Put on the shelf',
        put_off: 'Take off the shelf',
        name: 'Ticket name',
        status: 'Ticket status',
        goods_number: 'Ticket number',
        type_name: 'Ticket type',
        sales_volume: 'Inventory',
        sale_num: 'Sales volume',
        action: 'Operation',
        inventory: 'Inventory',
        sales_period: 'Sales period'
    }
};
